import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api`;

console.log('API_URL:', API_URL); // 在浏览器 console 中检查

const api = axios.create({
    baseURL: API_URL,
}); 

// Add token to requests if available
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['x-auth-token'] = token;
    }
    return config;
});

// Auth Service
export const auth = {
    register: (data: any) => api.post('/users/register', data),
    login: (data: any) => api.post('/users/login', data),
    getProfile: () => api.get('/users/me'),
    updateProfile: (data: { name?: string; email?: string; phone?: string }) => 
        api.put('/users/profile', data),
    changePassword: (data: { currentPassword: string; newPassword: string }) =>
        api.put('/users/password', data),
    deleteAccount: (password: string) =>
        api.delete('/users/account', { data: { password } }),
    verifyEmail: (token: string) => api.get(`/users/verify-email?token=${token}`),
};

// Password Service
export const password = {
    forgotPassword: (email: string) =>
        api.post('/forgot-password', { email }),

    resetPassword: (token: string, newPassword: string) =>
        api.post(`/reset-password/${token}`, { newPassword }),
};

// Wallet Service
export const wallets = {
    create: (data: any) => api.post('/wallets', data),
    getAll: () => api.get('/wallets'),
    update: (id: number, data: any) => api.put(`/wallets/${id}`, data),
    delete: (id: number) => api.delete(`/wallets/${id}`),
};

// Category Service
export const categories = {
    create: (data: any) => api.post('/categories', data),
    getAll: () => api.get('/categories'),
    update: (id: number, data: any) => api.put(`/categories/${id}`, data),
    delete: (id: number) => api.delete(`/categories/${id}`),
};

// Transaction Service
export const transactions = {
    create: (data: any) => api.post('/transactions', data),
    getAll: () => api.get('/transactions'),
    getByDateRange: (startDate: string, endDate: string) => 
        api.get(`/transactions/range?start_date=${startDate}&end_date=${endDate}`),
    update: (id: number, data: any) => api.put(`/transactions/${id}`, data),
    delete: (id: number) => api.delete(`/transactions/${id}`),
};
